import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
	name: 'tagFilterAny',
	pure: true
})

export class TagFilterAnyPipe implements PipeTransform {
	transform(items: any[], filter: number[]): any[] {
		if (!items || !filter) {
			return items;
		}

		return items.filter(item => item.tags.some(r => filter.indexOf(r) >= 0));
	}
}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/angular2-router-loader/src!./TypeScript/shared/pipes/tag-filter-any.pipe.ts